import { db } from '../firebase/firebase'
export const comments = async (email,idAsig,question) => {
    const comentarios = []
    await db.collection('Aula').doc(email)
    .collection('Subjects').doc(idAsig)
    .collection('comments').where("question","==", question).get()
    .then(query => {
        query.forEach(data => {
            comentarios.push({
                id: data.id,
                ...data.data()
            })
        })
    })
    return comentarios
}


export const updateNotaQuestion = async (email, idAsignatura, idComentario, nota) => {
    return await db.collection('Aula').doc(email)
        .collection('Subjects').doc(idAsignatura)
        .collection('comments').doc(idComentario)
        .update({
            qualification: parseFloat(nota)
        })
}


export const getCurso = async (email, idAsig) => {
    const asig = []
    await db.collection('Aula').doc(email).collection('Subjects')
    .doc(idAsig).get().then(query => {
        asig.push({...query.data()})
    })
    return asig
}

export const getProgressStudent = async (email,idAsig) => {
    const progress = []
    const asig = []
    await db.collection('Aula').doc(email).collection('Subjects')
    .doc(idAsig).get().then(query => {
        asig.push({...query.data()})
    })
    await db.collection('Aula').doc(email).collection('Subjects')
    .doc(idAsig).collection('progress')
    .where('domain','==', '@estudiantesunibague.edu.co')
    .orderBy('date','desc')
    .get().then(query => {
        query.forEach(data => {
            progress.push({
                id: data.id,
                cantThemes: asig[0].themes,
                ...data.data()
            })
        })
    })
    return progress;
}


export const Subjects = async (email) => {
    const nameAsig = []
    const students = []
    const likes = []
    await db.collection('Aula').doc(email).collection('Subjects')
    .get().then(query => {
        query.forEach(data => {
            nameAsig.push(data.data().nameSubject);
            students.push(data.data().students);
            likes.push(data.data().likes);
        })
    })
    return {nameAsig, students,likes}
}
